<template lang="pug">
.language-wrapper.country
  .dropdown
    button.btn.btn-secondary.dropdown-toggle(type='button' data-bs-toggle='dropdown' aria-expanded='false')
      .country-selection
        .country-flag
          img(src='images/flag/mng.png')
        .country-name MNG
    ul.dropdown-menu
      li
        a.dropdown-item(href='#')
          .country-selection
            .country-flag
              img(src='images/flag/mng.png')
            .country-name MNG
      li
        a.dropdown-item(href='#')
          .country-selection
            .country-flag
              img(src='images/flag/mng.png')
            .country-name MNG
</template>

<script>
export default{
  components: {},
  data() {
    return {
      countryOptions: []
    }
  },
  computed: {
		isLoggedIn(){
      return this.$store.getters.isLoggedIn
    }
	},
  mounted() {},
  methods: {}
}
</script>